import getStore from '../store/store';
import getPersonalSchedulingPage from '../services/getPersonalSchedulingPage';
import initializeSettings from '../actions/initializeSettings';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';

/**
 * Gets personal booking page settings and initialize store if not present.
 */
export default async function initPbpSettings(): Promise<boolean> {
    logUsage('PBP_SettingsLoadInitiated');

    let { publishingSettings } = getStore();
    if (!publishingSettings) {
        try {
            let pbpSettings = await getPersonalSchedulingPage();
            if (pbpSettings) {
                initializeSettings(pbpSettings);
            }
        } catch (e) {
            trace.warn(e.message || 'initPbpSettings failed');
        }
    }

    return true;
}
